import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { EventHttpService } from 'src/app/shared/services/http/event-http.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';

@UntilDestroy()
@Component({
  selector: 'app-delete-event-modal',
  templateUrl: './delete-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzIconModule,
    DragDropModule,
    NzRadioModule,
    NzButtonModule,
    NzModalModule,
  ],
})
export class DeleteEventModalComponent {
  readonly modal = inject(NzModalRef);
  readonly nzData = inject(NZ_MODAL_DATA);
  readonly eventHttp = inject(EventHttpService);
  deleteMode: 'series' | 'current' | 'future' | 'past' = 'current';

  close(arg?: any) {
    this.modal.destroy(arg);
  }

  submit() {
    if (this.nzData.IsRecurring) {
      this.nzData.deleteMode = this.deleteMode;
    }

    this.eventHttp
      .eventsUpdate({
        action: 'batch',
        added: [],
        changed: [],
        deleted: [this.nzData],
        params: {},
      })
      .subscribe(() => {
        this.close(true);
      });
  }
}
